/**
 * This helper exists as a better solution than using stopPropagation()
 * https://css-tricks.com/dangers-stopping-event-propagation/
 */
export function safeOnClick(handler, stopPropagation = false) {
  return (e) => {
    if (e?.defaultPrevented) {
      // another click handler has already handled this event
      return;
    }
    if (e?.preventDefault) {
      // let other click handlers know that "We've got this!"
      e.preventDefault();
    }

    // This should only work if specified by the stopPropagation parameter. Otherwise, it will break the dropdown menus
    if (e?.stopPropagation && stopPropagation) {
      // if the wrapper captures the click event
      e.stopPropagation();
    }

    if (handler) {
      // we defer the event to the next event loop so that any handlers listening for this
      // event further up the DOM can inspect the DOM to see what was clicked (if the handler
      // changes the DOM, e.g. removes the element that was clicked, then the handler further
      // up won't know what was clicked)
      setTimeout(() => handler(e), 1);
    }
  };
}

/**
 *  Prevents need for stopPropagation (see above).
 *  Handles another issue https://github.com/facebook/react/issues/3005
 */
export function safeOnChange(handler) {
  // Uses same logic as safeOnClick (but different name as it is used by onChange handlers).
  return safeOnClick(handler);
}

export function isDropdownMenuItem(element) {
  if (!element) {
    return false;
  }
  if (
    element.classList.contains('rc-menu') ||
    element.classList.contains('rc-menu-submenu') ||
    element.classList.contains('rc-menu-item')
  ) {
    return true;
  }
  return isDropdownMenuItem(element.parentElement);
}

export function isButtonWithClass(element, className) {
  if (!element) {
    return false;
  }
  if (element.classList.contains(className)) {
    return true;
  }
  return isButtonWithClass(element.parentElement, className);
}
